import { createStyles, makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => createStyles({
  '@global': {
    '*': {
      boxSizing: 'border-box',
      margin: 0,
      padding: 0,
    },
    html: {
      '-webkit-font-smoothing': 'antialiased',
      '-moz-osx-font-smoothing': 'grayscale',
      height: '100%',
      width: '100%'
    },
    body: {
      backgroundColor: '#fff',
      height: '100%',
      width: '100%'
    },
    a: {
      textDecoration: 'none'
    },
    '#root': {
      height: '100%',
      width: '100%'
    },
    /*button: {
      backgroundColor: '#1b66b3 !important',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#2181E3 !important',
        color: '#fff',
    },*/
    }}
));

const GlobalStyles = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
